import type { HTMLAttributes, ReactNode } from 'react';

export interface EmptyOverlayData {
  title?: ReactNode;
  icon?: ReactNode;
  text?: ReactNode;
  wrapperProps?: HTMLAttributes<HTMLDivElement>;
  children?: ReactNode;
}

export interface EmptyOverlayProps extends EmptyOverlayData {}
